// src/CalendarPage.js - AGGIORNATO CON CARICAMENTO DA FIRESTORE

import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'; // Aggiunto Views
import moment from 'moment';
import 'moment/locale/it';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CalendarPage.css';
import { db } from './firebase';
import { collection, query, where, onSnapshot, Timestamp, serverTimestamp, addDoc, updateDoc, doc, deleteDoc, getDocs } from 'firebase/firestore';
import { useUser } from './UserContext';
import { EventModal } from './EventModal'; // Importa il modale
import { toast } from 'react-toastify'; // Per feedback utente
import { createNotification } from './notificationService'; // <-- AGGIUNGI QUESTO IMPORT


moment.locale('it');
const localizer = momentLocalizer(moment);

const messages = {
  allDay: 'Tutto il giorno',
  previous: 'Prec',
  next: 'Succ',
  today: 'Oggi',
  month: 'Mese',
  week: 'Settimana',
  day: 'Giorno',
  agenda: 'Agenda',
  date: 'Data',
  time: 'Ora',
  event: 'Evento',
  showMore: total => `+ Altri ${total}`,
};


// NUOVA FUNZIONE per generare il tooltip
const getEventTooltip = (event) => {
    let tooltip = `Creato da: ${event.ownerName || 'Sconosciuto'}`;
    if (event.type === 'personal' && event.sharedWith && event.sharedWith.length > 0) {
        // In futuro potremmo caricare i nomi degli utenti condivisi qui
        tooltip += `\nCondiviso con: ${event.sharedWith.length} utent${event.sharedWith.length > 1 ? 'i' : 'e'}`;
    }
    return tooltip;
};

function CalendarPage() {
    const { userProfile } = useUser();
    const [events, setEvents] = useState([]);
    const [viewMode, setViewMode] = useState('shared');
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false); // Stato per il modale
    const [selectedEventInfo, setSelectedEventInfo] = useState(null); // Dati per il modale
    const [staffListForSharing, setStaffListForSharing] = useState([]); // *** NUOVO STATO ***
    // Permessi per creare/modificare eventi condivisi
    const canManageShared = ['completo', 'semi-completo'].includes(userProfile?.permissions?.calendar) 
  || userProfile?.role === 'Super Admin';
    const canDeleteShared = userProfile?.permissions?.calendar === 'completo' || userProfile?.role === 'Super Admin';
    const [currentDate, setCurrentDate] = useState(new Date());
    const [currentView, setCurrentView] = useState(Views.MONTH);

    // useEffect per caricare eventi (leggermente modificato per logica OR)
    useEffect(() => {
    if (!userProfile || !userProfile.centerId) return; // <-- AGGIUNGI QUESTA RIGA
    setIsLoading(true);
        const eventsCollectionRef = collection(db, 'centers', userProfile.centerId, 'calendarEvents');
        let q;

        // Costruiamo la query base in base alla vista
        if (viewMode === 'shared') {
            q = query(eventsCollectionRef, where('type', '==', 'shared'));
        } else { // 'personal'
            // Query più complessa per personali: O owner O in sharedWith
            // Firestore non supporta OR su campi diversi in modo nativo con 'where'.
            // Usiamo 'onSnapshot' e filtriamo lato client. Carichiamo tutti i personali.
            // Soluzione alternativa (più complessa): due listener separati e unire i risultati.
            q = query(eventsCollectionRef, where('type', '==', 'personal'));
        }

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            let fetchedEvents = querySnapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    start: data.start?.toDate(), // Usa optional chaining ?.toDate()
                    end: data.end?.toDate(),   // Usa optional chaining ?.toDate()
                };
            }).filter(event => event.start && event.end); // Filtra eventi senza date valide

            // Filtro client per vista personale
            if (viewMode === 'personal') {
                fetchedEvents = fetchedEvents.filter(event =>
                    event.ownerId === userProfile.uid || (event.sharedWith && event.sharedWith.includes(userProfile.uid))
                );
            }

             fetchedEvents = fetchedEvents.map(event => ({
                ...event,
                style: getEventStyle(event, userProfile.uid)
            }));

            setEvents(fetchedEvents);
            setIsLoading(false);
        }, (error) => {
            console.error("Errore nel leggere gli eventi:", error);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [viewMode, userProfile]);

    useEffect(() => {
        const fetchStaff = async () => {
            if (userProfile && userProfile.centerId) {// Carica solo se l'utente è loggato
                const staffSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'staff'));
                const staffOptions = staffSnapshot.docs
                    .map(doc => ({ value: doc.id, label: doc.data().name }))
                    // Opzionale: escludi l'utente corrente dalla lista se non vuoi che condivida con se stesso
                    // .filter(option => option.value !== userProfile.uid)
                    .sort((a, b) => a.label.localeCompare(b.label));
                setStaffListForSharing(staffOptions);
            }
        };
        fetchStaff();
    }, [userProfile]); // Ricarica se cambia l'utente

    // Funzione per applicare stili diversi agli eventi
    const getEventStyle = (event, currentUserId) => {
        let style = {
            backgroundColor: '#0d6efd', // Default blu
            borderRadius: '4px',
            opacity: 0.9,
            color: 'white',
            border: '0px',
            display: 'block',
            fontSize: '0.8rem',
            padding: '2px 4px'
        };

        if (event.type === 'personal') {
            if (event.ownerId === currentUserId) {
                // Evento personale creato da me
                style.backgroundColor = '#198754'; // Verde
            } else {
                // Evento personale condiviso con me
                style.backgroundColor = '#ffc107'; // Giallo/Arancio
                style.color = '#333'; // Testo scuro per leggibilità
            }
        } else {
             // Evento condiviso (puoi usare il default o un altro colore)
             style.backgroundColor = '#6c757d'; // Grigio
        }

        return style;
    };
    

    const handleSelectSlot = (slotInfo) => {
        // Controlla se l'utente può creare nel calendario corrente
        if (viewMode === 'shared' && !canManageShared) {
            toast.warn("Non hai i permessi per creare eventi nel calendario condiviso.");
            return;
        }
        setSelectedEventInfo({
            start: slotInfo.start, // Data/ora inizio dallo slot cliccato
            end: slotInfo.end,     // Data/ora fine dallo slot cliccato
            allDay: moment(slotInfo.end).isSame(moment(slotInfo.start).add(1, 'day'), 'minute'), // Controlla se dura 24h
            type: viewMode, // Pre-imposta il tipo in base alla vista corrente
        });
        setIsModalOpen(true);
    };

    // Apre modale per MODIFICARE evento esistente
    const handleSelectEvent = (event) => {
        setSelectedEventInfo(event); // Passa l'evento cliccato al modale
        setIsModalOpen(true);
    };

     // Apre modale per NUOVO evento (da pulsante generico)
    const handleAddNewEventClick = () => {
         if (viewMode === 'shared' && !canManageShared) {
            toast.warn("Non hai i permessi per creare eventi nel calendario condiviso.");
            return;
        }
        setSelectedEventInfo({ // Dati di default
            start: new Date(),
            end: moment().add(1, 'hour').toDate(),
            allDay: false,
            type: viewMode,
        });
        setIsModalOpen(true);
    };
    

    // --- FUNZIONE PER SALVARE (CREARE O AGGIORNARE) ---
    const handleSaveEvent = async (eventData) => {
         setIsLoading(true);
         const isCreating = !eventData.id; // Verifica se è una creazione

         // Trova l'evento originale PRIMA di preparare i dati da salvare (se è una modifica)
         let originalEvent = null;
         if (!isCreating) {
             originalEvent = events.find(e => e.id === eventData.id);
         }


         const dataToSave = {
             title: eventData.title,
             start: Timestamp.fromDate(eventData.start),
             end: Timestamp.fromDate(eventData.end),
             allDay: eventData.allDay,
             type: eventData.type,
             sharedWith: eventData.sharedWith || [], // Assicura che sia sempre un array
             ownerId: isCreating ? userProfile.uid : undefined,
             ownerName: isCreating ? userProfile.name : undefined,
             createdAt: isCreating ? serverTimestamp() : undefined,
             centerId: userProfile.centerId, // <-- AGGIUNGI QUESTA RIGA
         };
         Object.keys(dataToSave).forEach(key => dataToSave[key] === undefined && delete dataToSave[key]);

         try {
             let eventId = eventData.id; // ID per le notifiche
             if (isCreating) {
                 const docRef = await addDoc(collection(db, 'centers', userProfile.centerId, 'calendarEvents'), dataToSave);
                 eventId = docRef.id; // Ottieni l'ID del nuovo evento
                 toast.success("Evento creato!");
             } else {
                 const eventDocRef = doc(db, 'centers', userProfile.centerId, 'calendarEvents', eventData.id);
                 await updateDoc(eventDocRef, dataToSave);
                 toast.success("Evento aggiornato!");
             }

             // --- LOGICA NOTIFICHE DI CONDIVISIONE ---
             if (eventData.type === 'personal' && eventId) {
                 const originalSharedWith = originalEvent?.sharedWith || [];
                 const newSharedWith = dataToSave.sharedWith || [];

                 // Trova gli utenti A CUI È STATO APPENA CONDIVISO l'evento
                 const newlySharedUserIds = newSharedWith.filter(userId => !originalSharedWith.includes(userId));

                 if (newlySharedUserIds.length > 0) {
                     console.log("Invio notifiche a:", newlySharedUserIds);
                     // Invia notifica a ciascun nuovo utente
                     newlySharedUserIds.forEach(recipientId => {
                         // Assicurati di non notificare te stesso se ti aggiungi per errore
                         if (recipientId !== userProfile.uid) {
                             createNotification(
                                 recipientId,
                                 userProfile, // Mittente
                                 `ha condiviso un evento (${eventData.title}) con te.`,
                                 '/calendario' // Link alla pagina calendario
                             );
                         }
                     });
                 }
             }
             // --- FINE LOGICA NOTIFICHE ---


             setIsModalOpen(false);
             setSelectedEventInfo(null);
         } catch (error) {
             console.error("Errore salvataggio evento:", error);
             toast.error("Errore durante il salvataggio dell'evento.");
         } finally {
              setIsLoading(false);
         }
     };

    // --- FUNZIONE PER ELIMINARE ---
    const handleDeleteEvent = async (eventId) => {
         if (!eventId) return;
         setIsLoading(true);
         try {
             const eventDocRef = doc(db, 'centers', userProfile.centerId, 'calendarEvents', eventId);
             await deleteDoc(eventDocRef);
             toast.warn("Evento eliminato.");
             setIsModalOpen(false); // Chiudi il modale
             setSelectedEventInfo(null); // Resetta
         } catch (error) {
             console.error("Errore eliminazione evento:", error);
             toast.error("Errore durante l'eliminazione dell'evento.");
         } finally {
             setIsLoading(false);
         }
    };

    const handleNavigate = useCallback((newDate, view) => {
        // Per l'agenda, forziamo la navigazione per mese intero
        if (view === Views.AGENDA) {
            const currentMoment = moment(currentDate);
            const newMoment = moment(newDate);
            // Se stiamo cambiando mese (es. cliccando frecce), vai all'inizio del nuovo mese
            if (!newMoment.isSame(currentMoment, 'month')) {
                setCurrentDate(newMoment.startOf('month').toDate());
            } else {
            // Se clicchiamo 'Oggi' o navighiamo all'interno dello stesso mese (improbabile per l'agenda di default)
            // aggiorniamo comunque per riflettere la data selezionata (utile se l'utente clicca 'Oggi')
                setCurrentDate(newDate);
            }
        } else {
            // Comportamento standard per le altre viste
            setCurrentDate(newDate);
        }
    }, [currentDate]); // Aggiunta dipendenza

    const handleViewChange = useCallback((newView) => {
        // Quando si passa alla vista Agenda, assicuriamoci che la data
        // sia impostata all'inizio del mese corrente visualizzato.
        if (newView === Views.AGENDA) {
             setCurrentDate(moment(currentDate).startOf('month').toDate());
        }
        setCurrentView(newView);
    }, [currentDate]); // Aggiunta dipendenza
    // --- FINE NUOVA LOGICA ---

    // --- NUOVA LOGICA: Calcolo props dinamiche per Agenda ---
    let calendarDateProp = currentDate;
    let calendarLengthProp = undefined; // Default (solitamente 30 per agenda)

    if (currentView === Views.AGENDA) {
        const monthStart = moment(currentDate).startOf('month');
        calendarDateProp = monthStart.toDate(); // Forza l'inizio visualizzazione al 1° del mese
        calendarLengthProp = monthStart.daysInMonth(); // Imposta la lunghezza al n° di giorni del mese
    }


    return (
        <div className="calendar-page-container">
            {/* --- MODALE --- */}
            {isModalOpen && (
                <EventModal
                    eventInfo={selectedEventInfo}
                    onSave={handleSaveEvent}
                    onClose={() => { setIsModalOpen(false); setSelectedEventInfo(null); }}
                    onDelete={handleDeleteEvent} // Passa la funzione delete
                    staffList={staffListForSharing}
                />
            )}
        <div className="calendar-page-container">
            <div className="calendar-header">
                <h2>Calendario</h2>
                <div className="view-mode-toggle">
                    <button
                        className={viewMode === 'shared' ? 'active' : ''}
                        onClick={() => setViewMode('shared')}
                        disabled={isLoading} // Disabilita durante il caricamento
                    >
                        Condiviso
                    </button>
                    <button
                        className={viewMode === 'personal' ? 'active' : ''}
                        onClick={() => setViewMode('personal')}
                        disabled={isLoading} // Disabilita durante il caricamento
                    >
                        Personale
                    </button>
                </div>
                {/* --- PULSANTE AGGIUNGI EVENTO --- */}
                     {/* Mostra solo se si può creare nella vista corrente */}
                    {(viewMode === 'personal' || (viewMode === 'shared' && canManageShared)) && (
                         <button className="add-event-btn" onClick={handleAddNewEventClick}>
                             + Nuovo Evento
                         </button>
                    )}
                </div>
            </div>

            <div className="calendar-wrapper">
                {isLoading && <p>Caricamento...</p>}
                {!isLoading && (
                   <Calendar
                        // key={calendarKey} // Rimosso
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        style={{ height: 'calc(100vh - 180px)' }}
                        messages={messages}
                        views={['month', 'week', 'day', 'agenda']} // Assicurati che agenda sia qui
                        selectable
                        onSelectSlot={handleSelectSlot}
                        onSelectEvent={handleSelectEvent}
                        eventPropGetter={(event) => ({ style: event.style })}
                        tooltipAccessor={getEventTooltip}
                        // --- PROPS MODIFICATE ---
                        date={calendarDateProp}      // Usa la data calcolata
                        length={calendarLengthProp} // Usa la lunghezza calcolata (ha effetto solo su agenda)
                        view={currentView}
                        onNavigate={handleNavigate} // Usa il gestore modificato
                        onView={handleViewChange}     // Usa il gestore modificato
                        // --- FINE PROPS MODIFICATE ---
                    />
                )}
            </div>
        </div>
    );
}

export default CalendarPage;